export default {
  modelName: 'user',
  label: '使用者帳號',
  fields: {
    id: {
      type: 'text',
      label: 'ID',
      readonly: true,
    },
    email: {
      type: 'email',
      label: 'Email',
      rules: 'required|email',
      maxlength: 50,
      note: '新增後不可修改',
    },
    password: {
      type: 'text',
      label: '密碼',
      rules: 'required|min:6|nospace',
      updateNotNull: true,
      maxlength: 20,
    },
    name: {
      type: 'text',
      label: '名稱',
      rules: 'required',
      maxlength: 30,
    },
    is_active: {
      type: 'switch',
      label: '啟用',
      defaultValue: false,
    },
    avatar: {
      type: 'image',
      label: '頭像',
      uploadUrl: '/user/avatar/',
    },
    organizations: {
      type: 'hasMany',
      label: '所屬企業',
      textKey: 'name',
      modelName: 'organization',
    },
    factories: {
      type: 'hasMany',
      label: '所屬工廠',
      textKey: 'name',
      modelName: 'factory',
    },
    sequence: {
      type: 'text',
      label: '排序',
      maxlength: 10,
    },
    updated_at: {
      type: 'datetime',
      label: '最後更新時間',
      readonly: true,
    },
    updated_admin: {
      type: 'belongsTo',
      label: '最後更新人',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
    // updated_info: {
    //   type: "custom",
    //   label: "上次修改時間",
    //   getValue: (item) => {
    //     let _value = item.updated_at;
    //     if (item.updated_admin) {
    //       _value += `  ${item.updated_admin}`;
    //     }
    //     return _value;
    //   },
    // },
  },
};
